{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-26T02:31:38.528Z","source":"place-details"}